import React from "react";
import { useParams } from "react-router-dom";
import { TreasureLink } from "../../unicomponents/externalLinks/TreasureLink";

export default function Dashboard() {
  const { userrole } = useParams();
  const backgroundStyle = {
    backgroundImage: `url(/images/dashboard1.jpg)`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    width: "99vw",
    height: "100vh", // 높이를 화면 전체로 설정
  };
  return (
    <>
      <div style={backgroundStyle}></div>
      {userrole === "teacher" && <TreasureLink placement="home" />}
    </>
  );
}
